// src/selectors/issueEnrichers.ts
import { IIssueBoardApi } from "@mcapps/shared";
import { ICountersForAllAttributesWithFormula, IIssueApi } from "@schemas/issueSchema";
import { IProjectMemberApiItem } from "@schemas/projectSchema";
import { getIssuesWithFormulaAdded } from "../../../../mc-shared/sharedUtils";

export type IssueEnricher = (issue: IIssueApi, context: IEnrichmentContext) => IIssueApi;

export interface IEnrichmentContext {
  memberMap: Map<string, IProjectMemberApiItem>;
  formulaContext?: {
    issueBoard: IIssueBoardApi;
    sumsByFormula: ICountersForAllAttributesWithFormula;
  };
  // lägg till fler senare: tagMap, templateMap, etc.
}

// 1. Formel-berikning (flyttad hit!)
export const enrichWithFormula: IssueEnricher = (issue, ctx) => {
  if (!ctx.formulaContext) return issue;

  const { issueBoard, sumsByFormula } = ctx.formulaContext;
  const formulaAdded = getIssuesWithFormulaAdded({
    issues: [issue],
    issueBoard,
    sumsByFormula,
  });

  return formulaAdded[0] ?? issue;
};

// 2. Discipline
export const enrichAssignedToWithDiscipline: IssueEnricher = (issue, ctx) => {
  const assignedTo = issue.assignedTo;
  if (!assignedTo?._id) return issue;

  const member = ctx.memberMap.get(assignedTo._id.toString());
  if (!member?.disciplin) return issue;

  return {
    ...issue,
    assignedTo: {
      ...assignedTo,
      discipline: member.disciplin,
    },
  };
};

// Pipeline – lägg till nya här
export const ENRICHERS: IssueEnricher[] = [enrichWithFormula, enrichAssignedToWithDiscipline];
